module.exports = __webpack_public_path__ + "static/6-69fe419315ce2a6ca54741d714eede3e.jpg";